import { render, staticRenderFns } from "./MudarSenhaComponent.vue?vue&type=template&id=03973c32"
import script from "./MudarSenhaComponent.vue?vue&type=script&lang=js"
export * from "./MudarSenhaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports